<template>
  <div>
    <app-form-holder>
      <!--  -->
      <div v-if="isKeyValid === true && finishedReset === false">
        <app-form-title title="Provide a new password">
          Enter your new password.
        </app-form-title>
        <div txt-center style="min-height: 60px; padding: 10px 20px">
          <el-image lazy :style="`width: 160px;`" :src="img"></el-image>
        </div>
      </div>
      <!--  -->
      <!-- Login form -->
      <div v-loading="loading">
        <!-- Success -->
        <div v-if="finishedReset === true">
          <AppResetSucc />
        </div>
        <!-- Reset Link is Not -->
        <div v-if="isKeyValid === false">
          <AppResetLinkWrong />
        </div>
        <!--  -->
        <el-form
          v-if="finishedReset === false && isKeyValid === true"
          :rules="rules"
          @submit.prevent
          class="App-Styled-Form"
          :label-position="'top'"
          label-width="100px"
          :model="form"
          style="margin-top: 12px"
        >
          <!--  -->
          <!-- Password -->
          <div>
            <el-form-item prop="password" label="Password">
              <template v-slot:label>
                <el-icon>
                  <lock />
                </el-icon>
                Password
              </template>
              <el-input
                placeholder="********"
                type="password"
                v-model="form.password"
              />
            </el-form-item>
            <app-password-strength :password="form.password" />
          </div>
          <!--  -->
          <!--  -->
          <!-- Password -->
          <el-form-item
            prop="password"
            :error="
              confirmPassword.length > 0 && confirmPassword !== form.password
                ? `Passwords provided don't match`
                : ''
            "
          >
            <template v-slot:label>
              <el-icon>
                <lock />
              </el-icon>
              Confirm Password
            </template>
            <el-input
              placeholder="********"
              type="password"
              v-model="confirmPassword"
              show-password
            />
          </el-form-item>
          <!--  -->
          <!--  -->
          <div txt-center>
            <el-button
              :disabled="
                !form.password ||
                !confirmPassword ||
                form.password !== confirmPassword
              "
              is-block
              size="large"
              type="primary"
              icon="el-icon-check"
              @click="submit"
            >
              Save New Password
            </el-button>
          </div>
        </el-form>
      </div>
      <!--  -->
      <!--  -->
      <el-divider />
      <!--  -->
      <!-- Other links -->
      <div txt-center>
        <el-space
          w-100
          :fill="true"
          alignment="center"
          direction="vertical"
          :size="4"
        >
          <div>
            <router-link to="/login">
              <el-link type="primary">Sign In</el-link>
            </router-link>
          </div>
          <!--  -->
        </el-space>
      </div>
      <!--  -->
    </app-form-holder>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Message, Lock } from "@element-plus/icons";
import AppResetSucc from "./reset-succ.vue";
import AppResetLinkWrong from "./reset-link-failed.vue";
import { ErrorUtil } from "@/shared";
import img from "@/assets/illustrations/reset-password.svg";

@Options({
  components: { Message, Lock, AppResetSucc, AppResetLinkWrong },
})
export default class extends Vue {
  img = img;
  /**
   * Form data
   */
  confirmPassword = "";

  form = { key: "", password: undefined };
  rules = {
    password: [
      { required: true, message: "password is required!", trigger: "blur" },
      {
        message: "Please input strong password",
        trigger: ["blur", "change"],
      },
    ],
  };

  loading = true;
  isKeyValid = "";
  finishedReset = false;
  get key() {
    return this.$route.query.key;
  }

  mounted() {
    this.verifyKey();
  }
  /**
   * @verify the key
   */
  verifyKey() {
    this.loading = true;
    this.$api.main
      .get(`/v1/auth/verify-key/${this.key}`)
      .then((resp) => {
        this.form.key = this.key as string;
        this.isKeyValid = true as any;
      })
      .catch((err) => {
        this.isKeyValid = false as any;
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err, {
            message: "Could not verify your reset key.",
          }),
        });
      })
      .finally(() => (this.loading = false));
  }
  /**
   * @sends the submit request to the API
   */
  submit(): void {
    this.loading = true;
    this.$api.main
      .post("/v1/auth/reset", this.form)
      .then((resp) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "success",
          message: "Password reset successfully!.",
        });
        this.finishedReset = true;
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err),
        });
      })
      .finally(() => (this.loading = false));
  }
}
</script>

<style lang="scss"></style>
